<script setup>
// Phase 4.5: the notice is the kit's Alert (OverviewBanner); same rule for when it shows and how it is dismissed.
import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import OverviewBanner from './OverviewBanner.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';

const route = useRoute();
const router = useRouter();
const store = useStore();

const dismissed = ref(false);

const assistantId = computed(() => route.params.assistantId);
const inboxes = useMapGetter('polarisInboxes/getRecords');
const uiFlags = useMapGetter('polarisInboxes/getUIFlags');

// Only surface once we know the assistant has no connected inboxes.
const showBanner = computed(
  () =>
    !dismissed.value &&
    !uiFlags.value.fetchingList &&
    inboxes.value.length === 0
);

watch(
  assistantId,
  id => {
    dismissed.value = false;
    if (id) store.dispatch('polarisInboxes/get', { assistantId: id });
  },
  { immediate: true }
);

const goToInboxes = () => {
  router.push({
    name: 'polaris_assistants_inboxes_index',
    params: {
      accountId: route.params.accountId,
      assistantId: assistantId.value,
    },
  });
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <OverviewBanner
    v-if="showBanner"
    :text="$t('POLARIS.OVERVIEW.INBOX_BANNER.TEXT')"
    :action-label="$t('POLARIS.OVERVIEW.INBOX_BANNER.ACTION')"
    :dismiss-label="$t('POLARIS.OVERVIEW.INBOX_BANNER.DISMISS')"
    @action="goToInboxes"
    @dismiss="dismissed = true"
  />
</template>
